import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

type PageBodyProps = {
    children: React.ReactNode,
    className?: string,
    style?: React.CSSProperties,
    maxWidth?: 'sm' | 'default' | 'lg' | number,
};

PageBody.defaultProps = {
    className: '',
    style: {},
    maxWidth: 'default',
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    pageContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2, 3),
        backgroundColor: theme.palette.background.default,
    },
    container: {
        width: '100%',
        maxWidth: 1024,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto 0',
        alignSelf: 'center',
    },
}));

function PageBody(props: PageBodyProps): React.ReactElement {
    const {
        children,
        className,
        style = PageBody.defaultProps.style,
        maxWidth,
    } = props;
    const classes = useStyle();

    let innerMaxWidth = 1024;
    if (maxWidth === 'sm') {
        innerMaxWidth = 564;
    } else if (maxWidth === 'default') {
        innerMaxWidth = 564;
    } else if (maxWidth === 'lg') {
        innerMaxWidth = 1024;
    } else if (maxWidth && Number.isSafeInteger(maxWidth)) {
        innerMaxWidth = maxWidth;
    }

    return (
        <div className={clsx(classes.pageContainer, className)} style={{ ...style }}>
            <div className={classes.container} style={{ maxWidth: innerMaxWidth }}>
                { children }
            </div>
        </div>
    );
}

export { PageBody };
